import * as Const from '../constants';
import State from '../interfaces/state/TabState';

const initState: State = {
  currentTab: 0,
};

export default function tab(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.TAB_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.TAB_RECEIVE:
      return {
        ...state,
        currentTab: action.payload,
      };

    default:
      return state;
  }
}
